<template>
  <div v-if="!item.hidden" :class="{'isCloseBar': isCollapse}">
    <template v-if="hasOneShowingChild(item.children, item) && (!item.children || !item.children.length)">
      <div v-if="item.meta" @click="changePage(item)">
        <el-menu-item :index="resolvePath(item.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :currentRoute="item" :isCollapse="isCollapse"></item>
        </el-menu-item>
      </div>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item :currentRoute="item" :isCollapse="isCollapse"></item>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import Item from './Item'

export default {
  name: 'SidebarItem',
  components: { Item },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    },
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    // this.onlyOneChild = null
    return {
      onlyOneChild: null,
    }
  },
  methods: {
    changePage(item) {
      localStorage.removeItem('savePage');
      sessionStorage.removeItem('content_wrapper_top');
      this.$router.push(item.path);
    },
    hasOneShowingChild(children = [], parent) {
      // const showingChildren = children.filter(item => {
      //   if (item.hidden) {
      //     return false
      //   } else {
      //     // Temp set(will be used if only has one showing child)
      //     this.onlyOneChild = item
      //     return true
      //   }
      // })
      const showingChildren = children.filter(item => !item.hidden);
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      // if (isExternal(routePath)) {
        return routePath
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      return path.resolve(this.basePath, routePath)
    },
    // generateTitle
  }
}
</script>
<style>
.isCloseBar .el-submenu__icon-arrow {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/SidebarItem.vue